import { RequestFormBuilder } from "@/Components/RequestFormBuilder"
import { RouteName, routes, useRouter } from "@/Router/router";
import { Box } from "@mui/material"
import { useParams, useSearchParams, } from "react-router-dom";
import { ContentWrapper } from "vig-ui-library"
import { RequestFormBuilderProps } from "@/Components/RequestFormBuilder";

export const RequestFormView = () => {

    const { navigateToRequests } = useRouter();

    const { requestId } = useParams();

    const [searchParams] = useSearchParams();

    const requestType = searchParams.get("requestType");

    const pageSettings: RequestFormBuilderProps["pageSettings"] = {
        updateUrl: (newRequestId: string) => {
            let url = routes[RouteName.PREVIEW_UPDATE_REQUEST].path.replace(":requestId", newRequestId);
            if (requestType) url += `?requestType=${requestType}`;
            window.history.replaceState(null, "", url);
        },
        isPageForm: true,
    }

    return <ContentWrapper sx={{
        width: "100%",
        backgroundColor: "#f2f2f2",
    }}>
        <Box sx={{
            width: "100%",
            height: "100%",
            padding: { xs: "12px", sm: "24px", md: "40px" },
            display: "flex",
            justifyContent: "center",
        }}>
            <Box sx={{
                width: "100%",
                maxWidth: 682
            }}>
                <RequestFormBuilder
                    requestId={requestId ? requestId : undefined}
                    requestType={requestType ? parseInt(requestType) : undefined}
                    popupId=""
                    onCancelRequest={() => { }}
                    pageSettings={pageSettings}
                    closeForm={navigateToRequests}
                />
            </Box>
        </Box>
    </ContentWrapper>
}